export const lg_footer = {
    lg_footer_th: {
        privacy_policy: "นโยบายความเป็นส่วนตัว",
        information_security_policy:"นโยบายความมั่นคงปลอดภัยสารสนเทศ",
        information_technology_security_policy:"นโยบายความปลอดภัยเทคโนโลยีสารสนเทศ",
        terms_and_conditions:"ข้อกำหนดและเงื่อนไข",
        request_form:"จัดการสิทธิ์ข้อมูลของคุณ",
        terms_and_conditions_title_onpage:"ข้อกําหนดและเงื่อนไขการใช้บริการ Dmeets (Terms and Conditions of Use)",
        security_policy: "นโยบายความปลอดภัย",
        recording_consent_policy:"นโยบายการบันทึกการประชุม",
    },
    lg_footer_en: {
        privacy_policy: "Privacy Policy",
        information_security_policy:"Information Security Policy",
        information_technology_security_policy:"Information Technology Security Policy",
        terms_and_conditions:"Terms & Conditions",
        request_form:"Manage Your Data Rights",
        terms_and_conditions_title_onpage:"Dmeets Terms and Conditions of Use",
        security_policy: "Security Policy",
        recording_consent_policy:"Recording & Consent Policy",
    },
  };
